import { getStartOfCurrentDateInGivenTimezone } from '@/shared/date-time/index';

export default function isDateBeforeStartOfCurrentDateInGivenTimeZone(date: Date | string, timeZone: string): boolean {
    const zonedStartOfToday = getStartOfCurrentDateInGivenTimezone(timeZone);
    return zonedStartOfToday.getTime() > new Date(date).getTime();
}
